import { Box, styled } from '@mui/material';

const StyledTextFieldContainer = styled(Box)(() => ({
  borderRadius: '4px',
  padding: '1em',
  border: '1px solid rgb(211, 211, 211)',
}));

export default StyledTextFieldContainer;
